import React from "react";
import { connect } from "react-redux";
import { Breadcrumb } from "semantic-ui-react";

import { supportForUserPath, cancelPRSupportForUserPath } from "routes";
import { AdminContainer } from "./styled";
import { MenuButton } from "../styled";
import { MainBodyContent } from "components";

const SupportPRMainContainer = (props) => {
  const {
    history
  } = props;
  return (
    <MainBodyContent
      headerTitle="Purchase Requisition (PR)"
      breadcrumbs={
        <Breadcrumb
          icon="right angle"
          sections={[
            {
              key: "Support",
              content: "Support",
              link: true,
              onClick: () => {history.push(supportForUserPath)},
            },
            { key: "pr", content: "Purchase Requisition (PR)", active: true },
          ]}
        />
      }
    >
      <AdminContainer>
        <MenuButton title="Cancel PR" onClick={() => history.push(cancelPRSupportForUserPath)} />
      </AdminContainer>
    </MainBodyContent>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SupportPRMainContainer);
